// extracted by mini-css-extract-plugin
module.exports = {"GistsHero":"GistsHero_GistsHero__2pnM1"};